import React from 'react';
import { AxiosDeleteSecretApi } from '../../../utils/fetchApi/index';
import { connect } from 'react-redux';
import MainLayout from '../../../components/Layout/MainLayout';
import { Table, Button, message } from 'antd';
import { AxiosGetSecretApi } from '../../../utils/fetchApi';
import Card from '../../../components/Card';
import ModalWarning from '../../../components/CustomsAntd/ModalWarning';
import { getDataLoaiPhongBan } from '../../../redux/actions/search.action';
class ManagerDepartment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      isloading: false,
      pageSize: 10,

      pagination: {
        pageSize: 10,
        total: 200,
        current: 1,
      },

      IDNguoiDung: undefined,
      TenDangNhap: undefined,

      listLoaiPhongBan: this.props.listLoaiPhongBan,
    };

    this.columns = [
      {
        title: 'Id',
        dataIndex: 'key',
        align: 'left',
      },
      {
        title: 'Tên phòng ban',
        dataIndex: 'TenPhongBan',
        align: 'left',
      },
      {
        title: 'Mô tả',
        dataIndex: 'MoTa',
        align: 'left',
      },
      {
        title: 'Loại phòng ban',
        dataIndex: 'LoaiPhongBan',
        render: (cell, row, index) => {
          let text = '';
          this.state.listLoaiPhongBan.forEach((e) => {
            if (e.value === row.LoaiPhongBan) {
              text = e.label;
            }
          });
          return <div>{text}</div>;
        },
        align: 'left',
      },
      {
        title: 'Quận/ Huyện',
        dataIndex: 'TENHUYEN',
        align: 'left',
      },

      {
        title: 'Phường/ Xã',
        dataIndex: 'TenPhuong',
        align: 'left',
      },

      {
        title: 'Hành động',
        render: (cell, row, index) => {
          return (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{ display: 'flex' }}>
                <Button
                  onClick={() => {
                    this.props.history.push(
                      `/ql-nhom-nguoi-dung/${row.MaPhongBan}/chinh-sua`
                    );
                  }}
                  style={{ marginRight: '10px', padding: 0 }}
                  type='link'
                >
                  <i
                    className='fas fa-edit'
                    style={{ fontSize: '18px', color: '#1F86EB' }}
                  ></i>
                </Button>

                <Button
                  type='link'
                  onClick={() => {
                    this.showModalDelete(row.MaPhongBan, row.TenPhongBan);
                  }}
                >
                  <i
                    className='far fa-trash-alt'
                    style={{ fontSize: '18px', color: 'red' }}
                  />
                </Button>
              </div>
            </div>
          );
        },
        align: 'center',
        width: 150,
      },
    ];
  }
  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  componentDidMount() {
    window.onbeforeunload = null;
    if (this.props.listLoaiPhongBan.length === 0)
      this.props.getDataLoaiPhongBan();
    this.getAllData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.listLoaiPhongBan !== this.props.listLoaiPhongBan) {
      this.setState({ listLoaiPhongBan: this.props.listLoaiPhongBan });
    }
  }

  async getAllData() {
    this.setStateAsync({
      isloading: true,
    });
    try {
      let response = await AxiosGetSecretApi(
        `/api/group-user/search?curPage=${this.state.pagination.current}&pageSize=${this.state.pagination.pageSize}`
      );
      let dataTable = [];
      if (response && response.dataResult) {
        dataTable = response.dataResult.map((o, index) => {
          return {
            ...o,
            key: o.MaPhongBan,
          };
        });
      }
      this.setStateAsync({
        dataTable: dataTable,
        pagination: { ...response.dataPaginate, showSizeChanger: false },
        isloading: false,
      });
    } catch (error) {
      this.setState({ isloading: false });
    }
  }

  showModalDelete(id, username) {
    this.setState({
      isVisiableModal: true,
      IDNguoiDung: id,
      TenDangNhap: username,
    });
  }

  onCancelModal = () => {
    this.setState({ isVisiableModal: false });
  };

  onDeleteUser = async () => {
    let id = this.state.IDNguoiDung;
    let username = this.state.TenDangNhap;
    this.setState({ isVisiableModal: false });
    let response = await AxiosDeleteSecretApi(`/api/group-user/${id}`);
    if (response.success === true) {
      message.success(`Xóa phòng ban ${username} thành công!`);
      this.setState({ showProgressBar: false });
      this.getAllData();
    } else {
      message.error('Xóa phòng ban không thành công');
    }
  };

  handleTableChange = async (pagination) => {
    await this.setStateAsync({ pagination });
    this.getAllData();
  };

  render() {
    return (
      <MainLayout {...this.props} title={'Quản lý người dùng'}>
        <div className='page-with-card'>
          <Card title='Quản lý phòng ban'>
            <div className='manager-user'>
              <Button
                className='button-create'
                onClick={() => {
                  this.props.history.push('/ql-nhom-nguoi-dung/tao-moi');
                }}
                type='primary'
              >
                <i className='fas fa-plus-square icon-create'></i>
                Tạo mới phòng ban
              </Button>

              <Table
                size='small'
                columns={this.columns}
                locale={{ emptyText: 'Không có dữ liệu' }}
                dataSource={this.state.dataTable}
                pagination={{
                  ...this.state.pagination,
                  showSizeChanger: false,
                }}
                loading={this.state.isloading}
                rowKey={(record) => record.IDNguoiDung}
                onChange={this.handleTableChange}
              />
            </div>
          </Card>
        </div>

        <ModalWarning
          visible={this.state.isVisiableModal}
          title={'Bạn có chắc muốn xoá ?'}
          onOk={this.onDeleteUser}
          onCancel={this.onCancelModal}
        ></ModalWarning>
      </MainLayout>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    listLoaiPhongBan: state.search.listLoaiPhongBan,
  };
};

const mapDispatchToProps = {
  getDataLoaiPhongBan: getDataLoaiPhongBan,
};

export default connect(mapStateToProps, mapDispatchToProps)(ManagerDepartment);
